import React, { useState, useEffect } from 'react';
import './App.css';
import { STORAGE_KEYS } from './constants/storageKeys';
import { ToastContainer } from './components/Toast';

import LoginScreen from './screens/LoginScreen';
import ExpenseListScreen from './screens/ExpenseListScreen';
import ExpenseFormScreen from './screens/ExpenseFormScreen';
import EmpCreditListScreen from './screens/EmpCreditListScreen';
import EmpCreditFormScreen from './screens/EmpCreditFormScreen';

function App() {
  const [currentScreen, setCurrentScreen] = useState('Splash');
  const [screenParams, setScreenParams] = useState({});

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    if (token) {
      setCurrentScreen('ExpenseList');
    } else {
      setCurrentScreen('Login');
    }
  }, []);

  const navigate = (screen, params = {}) => {
    setCurrentScreen(screen);
    setScreenParams(params);
  };

  const goBack = () => {
    if (currentScreen === 'ExpenseForm' || currentScreen === 'EmpCreditList' || currentScreen === 'EmpCreditForm') {
      navigate('ExpenseList');
    }
  };

  if (currentScreen === 'Splash') {
    return (
      <div className="app-shell" style={{ justifyContent: 'center', alignItems: 'center' }}>
        <div className="spinner spinner--gold" />
      </div>
    );
  }

  return (
    <>
      {currentScreen === 'Login' && (
        <LoginScreen onLoginSuccess={() => navigate('ExpenseList')} />
      )}
      {currentScreen === 'ExpenseList' && (
        <ExpenseListScreen navigate={navigate} onLogout={() => navigate('Login')} />
      )}
      {currentScreen === 'ExpenseForm' && (
        <ExpenseFormScreen params={screenParams} onBack={goBack} />
      )}
      {currentScreen === 'EmpCreditList' && (
        <EmpCreditListScreen params={screenParams} onBack={goBack} />
      )}
      {currentScreen === 'EmpCreditForm' && (
        <EmpCreditFormScreen onBack={goBack} />
      )}
      <ToastContainer />
    </>
  );
}

export default App;
